<script>
import {useCatalogStore} from "@js/store/CatalogStore.js";
import VueSlider from "vue-3-slider-component";
import FormattedNumberInput from "@js/components/Input/FormattedNumberInput.vue";
import CatalogFilterBlockLoading from "@js/components/Sections/Catalog/Components/CatalogFilterBlockLoading.vue";
import CatalogFilterBlock from "@js/components/Sections/Catalog/Components/CatalogFilterBlock.vue";
import CatalogFilterLoading from "@js/components/Sections/Catalog/Components/CatalogFilterLoading.vue";
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue";
import CustomCheckbox from "@js/components/Input/CustomCheckbox.vue";
import ColorCircle from "@js/components/Statuses/ColorCircle.vue";
import {isMobile} from "@js/helpers.ts";

export default {
    name: "CatalogFilter",
    components: {
        ColorCircle,
        CustomCheckbox,
        NumberFormatComponent,
        CatalogFilterLoading,
        CatalogFilterBlock,
        CatalogFilterBlockLoading,
        FormattedNumberInput,
        VueSlider
    },
    data() {
        return {
            reset_hovered: false,
            getCatalogTimeout: null,
            filterDescriptions: {
                colors: "Цвет плитки в ванной или на кухне влияет на общее восприятие интерьера. Подбирайте оттенки, которые гармонично впишутся в атмосферу вашего дома.",
                surfaces: "Глянцевая плитка отлично подходит для кухонного фартука — она легко очищается от жирных брызг. Для ванной комнаты лучше выбрать матовую плитку: на ней почти не остаются следы от воды. Полуматовая поверхность характерна для лаппатированной и сатинированной плитки, а также керамогранита.",
                brands: "Выберите одного или несколько брендов, чью продукцию хотите посмотреть. Наведите курсор на флаг рядом с названием фабрики, чтобы узнать страну-производителя.",
                purposes: "Плитка для пола и стен используется соответственно для укладки на пол или стены. Декоры и панно украшены узорами и рисунками. Бордюр представляет собой узкий декоративный элемент, разделяющий поверхности. Плинтус предназначен для закрытия стыка между стеной и полом. Ступени применяются для облицовки лестничных конструкций, а подступенник закрывает вертикальную часть ступени.",
                countries: "Плитка для ванной устойчива к высокой влажности и резким перепадам температур. Кухонная плитка хорошо переносит пар, влагу, запахи и загрязнения жиром. Для бассейнов используют ударопрочные материалы с минимальным водопоглощением. Плитка для коридора должна обладать повышенной износостойкостью и легко очищаться от частых загрязнений. Для облицовки печей и каминов применяется термостойкая плитка, выдерживающая нагрев до 1100 °C.",
                rectification: "Ректификованная плитка имеет ровно обрезанные края, что позволяет укладывать её с минимальными швами шириной 1,5–2 мм. У необработанной плитки края остаются натуральными, с небольшим скруглением (фацетом) на торцах.",
                sale: "Количество товара ограничено, уточняйте наличие по телефону. Обратите внимание: товары с маркировкой «Распродажа» не подлежат обмену и возврату в соответствии с Законом «О защите прав потребителей».",
                mix: "Плитка с эффектом микс включает в каждую коробку набор различных рисунков, сформированный производителем. Магазин не влияет на комплектацию наборов, поэтому наличие или отсутствие определённых рисунков в заказе не является основанием для возврата или обмена товара.",
                forms: "Классические формы плитки — квадрат и прямоугольник. Для оригинальных раскладок используют плитку в форме шестигранника, октагона, шеврона, ромба, треугольника, круга и других фигур. Фриз — это объемный завершающий бордюрный элемент. Карандаш — узкий бордюр шириной до 3 см. Угловые элементы предназначены для аккуратного оформления углов.",
                depth: "Толщина плитки указана в миллиметрах. Обычно настенная плитка имеет толщину около 7 мм, а напольная — немного больше, в пределах 8–9 мм.",
                chip_types: "Квадратная — классическая форма мозаики, знакомая своей универсальностью.\n" +
                    "Прямоугольная — более разнообразный вариант: чипы могут быть узкими полосками или напоминать крупные кирпичики.\n" +
                    "Неравномерная — мозаика с фишками произвольной формы, часто напоминает гальку или осколки камня.\n" +
                    "Шестиугольная — напоминает соты, отлично подходит для сочетания с шестигранной напольной плиткой.\n" +
                    "Октагональная — восьмиугольные элементы мозаики обычно дополняются маленькими квадратными вставками; нередко используется натуральный камень.\n" +
                    "Шеврон — мозаика, выложенная \"ёлочкой\" или \"зигзагом\", прекрасно смотрится в необычных интерьерах.\n" +
                    "Круглая — может использоваться как отдельно, так и в комбинации с квадратными элементами.\n" +
                    "Овальная — часто встречается в мозаике из гальки или её имитации.\n" +
                    "Ромбовидная и треугольная — мозаика для нестандартных и креативных дизайнерских решений.",
                fastenings: "На сетке — мозаичные элементы закреплены с тыльной стороны на сетчатой основе, что облегчает укладку. Благодаря фиксированному расположению фишек проще выдерживать равные зазоры между ними.\n" +
                    "На бумаге — мозаика покрыта бумагой с клеевым слоем с лицевой стороны. После приклеивания к основанию бумагу удаляют.\n" +
                    "На полимерных связках — чипы соединяются эластичными PVC-перемычками, при этом тыльная сторона остаётся открытой для лучшего сцепления с клеевым раствором.\n" +
                    "\n",
            }
        }
    },
    methods: {
        /**
         * Вернёт count для переданного булева значения или undefined.
         */
        getCount(value) {
            const entry = this.catalogStore.filter_data.is_mixed_pattern
                .find(item => item.value === value);
            return entry ? entry.count : undefined;
        },
        filterOptionsByQuery(options, query) {
            if (!query || options.length <= 7) return options;
            return options.filter(option =>
                option.title?.toLowerCase().includes(query.toLowerCase())
            );
        }
    },
    computed: {
        checkIMobile() {
            return isMobile
        }
    },
    setup() {
        const catalogStore = useCatalogStore()

        return {catalogStore}
    }
}
</script>

<template>
    <div class="w-full" v-if="catalogStore.loadings.filter_first_load">
        <div class="relative flex items-center justify-between yellow-border pb-2 border-b border-gray-200"
             :class="{'yellow-border-rtl':reset_hovered}">
            <div class="flex items-center gap-1 font-medium"
                 v-if="catalogStore.loadings.catalog_loaded">
                Найдено:
                <NumberFormatComponent :number="catalogStore.total_result ?? 0"/>
            </div>
            <div v-else>
                <div role="status" class="max-w-sm animate-pulse">
                    <div class="h-6 bg-gray-300 rounded w-24 animate-pulse"></div>
                </div>
            </div>
            <div @click.prevent="catalogStore.resetFilter"
                 @mouseenter="reset_hovered = true"
                 @mouseleave="reset_hovered = false"
                 class="font-sm font-semibold flex items-center fill-black cursor-pointer transition">
                <svg class="w-5 h-5 me-1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M362.667 256a106.667 106.667 0 0 1 106.666 106.667c0 58.91-47.756 106.666-106.666 106.666S256 421.577 256 362.667 303.756 256 362.667 256Zm0 21.333c-47.129 0-85.334 38.205-85.334 85.334 0 47.128 38.205 85.333 85.334 85.333C409.795 448 448 409.795 448 362.667c0-47.129-38.205-85.334-85.333-85.334Zm36.543 33.706 15.085 15.085-36.544 36.543 36.544 36.543-15.085 15.085-36.543-36.544-36.543 36.544-15.085-15.085 36.543-36.543-36.543-36.543 15.085-15.085 36.543 36.543 36.543-36.543ZM384 85.333l-149.333 182v122H192v-122l-149.333-182H384Z"
                        fill-rule="evenodd"/>
                </svg>
                Сбросить
            </div>
        </div>
        <!--Цвет-->
        <CatalogFilterBlock title="Цвет" :description="filterDescriptions.colors"
                            :enableSearch="catalogStore.filter_data.colors.length > 7"
                            searchPlaceholder="Поиск по цвету"
                            v-slot="{ searchQuery }"
                            v-if="catalogStore.filter_data.colors.length">
            <div v-for="(item, key) in filterOptionsByQuery(catalogStore.filter_data.colors, searchQuery)" :key="key"
                 class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-colors-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.colors"/>
                    <label :for="'filter-colors-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            <ColorCircle v-if="item.hex" :hex="item.hex"/>
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
            <p v-show="!filterOptionsByQuery(catalogStore.filter_data.colors, searchQuery).length"
               class="text-sm text-gray-500 pt-2">Ничего не найдено</p>
        </CatalogFilterBlock>
        <!--Поверхность-->
        <CatalogFilterBlock title="Поверхность" :description="filterDescriptions.surfaces"
                            :default_open="!checkIMobile()"
                            v-if="catalogStore.filter_data.surfaces.length">
            <div v-for="(item, key) in catalogStore.filter_data.surfaces" :key="key" class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-surfaces-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.surfaces"/>
                    <label :for="'filter-surfaces-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span>
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
        <!--Производитель-->
        <CatalogFilterBlock title="Производитель" :description="filterDescriptions.brands"
                            :enableSearch="catalogStore.filter_data.brands.length > 7"
                            searchPlaceholder="Поиск по производителю"
                            v-slot="{ searchQuery }"
                            :default_open="!checkIMobile()"
                            v-if="catalogStore.filter_data.brands.length">
            <div v-for="(item, key) in filterOptionsByQuery(catalogStore.filter_data.brands, searchQuery)" :key="key"
                 class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-brands-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.brands"/>
                    <label :for="'filter-brands-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            <img v-if="item.country_code"
                                 :src="'/assets/flags/' + item.country_code+'.svg'" title="flag" alt="flag"
                                 class="h-3 w-4 rounded object-cover"/>
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
            <p v-show="!filterOptionsByQuery(catalogStore.filter_data.brands, searchQuery).length"
               class="text-sm text-gray-500 pt-2">Ничего не найдено</p>
        </CatalogFilterBlock>
        <!--Назначение-->
        <CatalogFilterBlock title="Назначение" :description="filterDescriptions.purposes"
                            :default_open="!checkIMobile()"
                            v-if="catalogStore.filter_data.purposes.length">
            <div v-for="(item, key) in catalogStore.filter_data.purposes" :key="key" class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-purposes-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.purposes"/>
                    <label :for="'filter-purposes-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
        <!--Размер-->
        <CatalogFilterBlock title="Размер" v-if="catalogStore.filter_data.sizes.length"
                            :enableSearch="catalogStore.filter_data.sizes.length > 7"
                            searchPlaceholder="Поиск по размеру"
                            v-slot="{ searchQuery }"
                            :default_open="!checkIMobile()">
            <div v-for="(item, key) in filterOptionsByQuery(catalogStore.filter_data.sizes, searchQuery)" :key="key"
                 class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-sizes-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.sizes"/>
                    <label :for="'filter-sizes-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
            <p v-show="!filterOptionsByQuery(catalogStore.filter_data.sizes, searchQuery).length"
               class="text-sm text-gray-500 pt-2">Ничего не найдено</p>
        </CatalogFilterBlock>
        <!--Помещение-->
        <CatalogFilterBlock title="Помещение" v-if="catalogStore.filter_data.rooms.length"
                            :enableSearch="catalogStore.filter_data.rooms.length > 7"
                            searchPlaceholder="Поиск по помещению"
                            v-slot="{ searchQuery }"
                            :default_open="!checkIMobile()">
            <div v-for="(item, key) in filterOptionsByQuery(catalogStore.filter_data.rooms, searchQuery)" :key="key"
                 class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-rooms-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.rooms"/>
                    <label :for="'filter-rooms-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
            <p v-show="!filterOptionsByQuery(catalogStore.filter_data.rooms, searchQuery).length"
               class="text-sm text-gray-500 pt-2">Ничего не найдено</p>
        </CatalogFilterBlock>
        <!--Страна-->
        <CatalogFilterBlock title="Страна" :description="filterDescriptions.countries"
                            :enableSearch="catalogStore.filter_data.countries.length > 7"
                            searchPlaceholder="Поиск по стране"
                            v-slot="{ searchQuery }"
                            v-if="catalogStore.filter_data.countries.length"
                            :default_open="!checkIMobile()">
            <div v-for="(item, key) in filterOptionsByQuery(catalogStore.filter_data.countries, searchQuery)" :key="key"
                 class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-countries-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.countries"/>
                    <label :for="'filter-countries-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            <img v-if="item.country_code"
                                 :src="'/assets/flags/' + item.country_code+'.svg'" title="flag" alt="flag"
                                 class="h-3 w-4 rounded object-cover"/>
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
            <p v-show="!filterOptionsByQuery(catalogStore.filter_data.countries, searchQuery).length"
               class="text-sm text-gray-500 pt-2">Ничего не найдено</p>
        </CatalogFilterBlock>
        <!--Рисунок-->
        <CatalogFilterBlock title="Рисунок" v-if="catalogStore.filter_data.patterns.length"
                            :enableSearch="catalogStore.filter_data.patterns.length > 7"
                            searchPlaceholder="Поиск по рисунку"
                            v-slot="{ searchQuery }"
                            :default_open="!checkIMobile()">
            <div v-for="(item, key) in filterOptionsByQuery(catalogStore.filter_data.patterns, searchQuery)" :key="key"
                 class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-patterns-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.patterns"/>
                    <label :for="'filter-patterns-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
            <p v-show="!filterOptionsByQuery(catalogStore.filter_data.patterns, searchQuery).length"
               class="text-sm text-gray-500 pt-2">Ничего не найдено</p>
        </CatalogFilterBlock>
        <!--Ректификат-->
        <CatalogFilterBlock title="Ректификат" :description="filterDescriptions.rectification"
                            :default_open="false">
            <div v-for="(item, key) in catalogStore.filter_data.is_rectification" :key="key" class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-is_rectification-' + key"
                                    :value="item.value"
                                    :disabled="item.count === 0"
                                    v-model="catalogStore.filter.is_rectification"/>
                    <label :for="'filter-is_rectification-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.value ? 'Да' : 'Нет' }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
        <!--Распродажа-->
        <CatalogFilterBlock title="Распродажа" :description="filterDescriptions.sale"
                            :default_open="false">
            <div v-for="(item, key) in catalogStore.filter_data.is_promotional" :key="key" class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-is_promotional-' + key"
                                    :value="item.value"
                                    :disabled="item.count === 0"
                                    v-model="catalogStore.filter.is_promotional"/>
                    <label :for="'filter-is_promotional-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.value ? 'Да' : 'Нет' }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
        <!--Микс-->
        <CatalogFilterBlock title="Микс" :description="filterDescriptions.mix"
                            :default_open="false">
            <div v-for="(item, key) in catalogStore.filter_data.is_mixed_pattern" :key="key" class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-is_mixed_pattern-' + key"
                                    :value="item.value"
                                    :disabled="item.count === 0"
                                    v-model="catalogStore.filter.is_mixed_pattern"/>
                    <label :for="'filter-is_mixed_pattern-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.value ? 'Да' : 'Нет' }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
        <!--Форма-->
        <CatalogFilterBlock title="Форма" :description="filterDescriptions.forms"
                            :enableSearch="catalogStore.filter_data.forms.length > 7"
                            searchPlaceholder="Поиск по форме"
                            v-slot="{ searchQuery }"
                            :default_open="false" v-if="catalogStore.filter_data.forms.length">
            <div v-for="(item, key) in filterOptionsByQuery(catalogStore.filter_data.forms, searchQuery)" :key="key"
                 class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-forms-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.forms"/>
                    <label :for="'filter-forms-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
            <p v-show="!filterOptionsByQuery(catalogStore.filter_data.forms, searchQuery).length"
               class="text-sm text-gray-500 pt-2">Ничего не найдено</p>
        </CatalogFilterBlock>
        <!--Ширина-->
        <CatalogFilterBlock title="Ширина" :default_open="false">
            <div v-if="catalogStore.loadings.filter_limits_loaded">
                <VueSlider v-if="catalogStore.filter.width"
                           v-model="catalogStore.filter.width"
                           :min="catalogStore.filter_data.limits.width[0]"
                           :max="catalogStore.filter_data.limits.width[1]"
                           :interval="catalogStore.widthInterval"
                           :silent="true"
                           tooltip="none"/>
                <div class="grid grid-cols-2 gap-5 mt-4">
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput placeholder=" " name="cf_width_from" id="cf_width_from"
                                              :min="catalogStore.filter_data.limits.width[0]"
                                              :max="catalogStore.filter_data.limits.width[1]"
                                              v-model="catalogStore.filter.width[0]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_width_from"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Ширина от
                        </label>
                    </div>
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_width_to" id="cf_width_to" placeholder=" "
                                              :min="catalogStore.filter_data.limits.width[0]"
                                              :max="catalogStore.filter_data.limits.width[1]"
                                              v-model="catalogStore.filter.width[1]"
                                              :interval="catalogStore.widthInterval"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"
                        />
                        <label for="cf_width_to"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Ширина до
                        </label>
                    </div>
                </div>
            </div>
            <CatalogFilterBlockLoading v-else/>
        </CatalogFilterBlock>
        <!--Длина-->
        <CatalogFilterBlock title="Длина" :default_open="false">
            <div v-if="catalogStore.loadings.filter_limits_loaded">
                <VueSlider v-if="catalogStore.filter.length"
                           v-model="catalogStore.filter.length"
                           :min="catalogStore.filter_data.limits.length[0]"
                           :max="catalogStore.filter_data.limits.length[1]"
                           :interval="catalogStore.lengthInterval"
                           :silent="true"
                           tooltip="none"/>
                <div class="grid grid-cols-2 gap-5 mt-4">
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput placeholder=" " name="cf_length_from" id="cf_length_from"
                                              :min="catalogStore.filter_data.limits.length[0]"
                                              :max="catalogStore.filter_data.limits.length[1]"
                                              v-model="catalogStore.filter.length[0]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_length_from"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Длина от
                        </label>
                    </div>
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_length_to" id="cf_length_to" placeholder=" "
                                              :min="catalogStore.filter_data.limits.length[0]"
                                              :max="catalogStore.filter_data.limits.length[1]"
                                              v-model="catalogStore.filter.length[1]"
                                              :interval="catalogStore.lengthInterval"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"
                        />
                        <label for="cf_length_to"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Длина до
                        </label>
                    </div>
                </div>
            </div>
            <CatalogFilterBlockLoading v-else/>
        </CatalogFilterBlock>
        <!--Толщина-->
        <CatalogFilterBlock title="Толщина" :description="filterDescriptions.depth"
                            :default_open="false">
            <div v-if="catalogStore.loadings.filter_limits_loaded">
                <VueSlider v-if="catalogStore.filter.depth"
                           v-model="catalogStore.filter.depth"
                           :min="catalogStore.filter_data.limits.depth[0]"
                           :max="catalogStore.filter_data.limits.depth[1]"
                           :interval="catalogStore.depthInterval"
                           :silent="true"
                           tooltip="none"/>
                <div class="grid grid-cols-2 gap-5 mt-4">
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput placeholder=" " name="cf_depth_from" id="cf_depth_from"
                                              :min="catalogStore.filter_data.limits.depth[0]"
                                              :max="catalogStore.filter_data.limits.depth[1]"
                                              v-model="catalogStore.filter.depth[0]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_depth_from"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Толщина от
                        </label>
                    </div>
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_depth_to" id="cf_depth_to" placeholder=" "
                                              :min="catalogStore.filter_data.limits.depth[0]"
                                              :max="catalogStore.filter_data.limits.depth[1]"
                                              v-model="catalogStore.filter.depth[1]"
                                              :interval="catalogStore.depthInterval"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"
                        />
                        <label for="cf_depth_to"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Толщина до
                        </label>
                    </div>
                </div>
            </div>
            <CatalogFilterBlockLoading v-else/>
        </CatalogFilterBlock>
        <!--Цена-->
        <CatalogFilterBlock title="Цена" :default_open="false">
            <div v-if="catalogStore.loadings.filter_limits_loaded">
                <VueSlider v-model="catalogStore.filter.price"
                           :min="catalogStore.filter_data.limits.price[0]"
                           :max="catalogStore.filter_data.limits.price[1]"
                           :interval="catalogStore.priceInterval"
                           :silent="true"
                           tooltip="none"/>
                <div class="grid grid-cols-2 gap-5 mt-4">
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput placeholder=" " name="cf_price_from" id="cf_price_from"
                                              :min="catalogStore.filter_data.limits.price[0]"
                                              :max="catalogStore.filter_data.limits.price[1]"
                                              v-model="catalogStore.filter.price[0]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_price_from"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Цена от
                        </label>
                    </div>
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_price_to" id="cf_price_to" placeholder=" "
                                              :min="catalogStore.filter_data.limits.price[0]"
                                              :max="catalogStore.filter_data.limits.price[1]"
                                              v-model="catalogStore.filter.price[1]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"
                        />
                        <label for="cf_price_to"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Цена до
                        </label>
                    </div>
                </div>
            </div>
            <CatalogFilterBlockLoading v-else/>
        </CatalogFilterBlock>
        <!--Высота фишки-->
        <CatalogFilterBlock title="Высота фишки" :default_open="false"
                            v-if="catalogStore.category_id === 3">
            <div v-if="catalogStore.loadings.filter_limits_loaded">
                <VueSlider v-model="catalogStore.filter.chip_height"
                           :min="catalogStore.filter_data.limits.chip_height[0]"
                           :max="catalogStore.filter_data.limits.chip_height[1]"
                           :interval="catalogStore.chipHeightInterval"
                           :silent="true"
                           tooltip="none"/>
                <div class="grid grid-cols-2 gap-5 mt-4">
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput placeholder=" " name="cf_chip_height_from" id="cf_chip_height_from"
                                              :min="catalogStore.filter_data.limits.chip_height[0]"
                                              :max="catalogStore.filter_data.limits.chip_height[1]"
                                              v-model="catalogStore.filter.chip_height[0]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_chip_height_from"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Высота от
                        </label>
                    </div>
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_chip_height_to" id="cf_chip_height_to" placeholder=" "
                                              :min="catalogStore.filter_data.limits.chip_height[0]"
                                              :max="catalogStore.filter_data.limits.chip_height[1]"
                                              v-model="catalogStore.filter.chip_height[1]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"
                        />
                        <label for="cf_chip_height_to"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Высота до
                        </label>
                    </div>
                </div>
            </div>
            <CatalogFilterBlockLoading v-else/>
        </CatalogFilterBlock>
        <!--Ширина фишки-->
        <CatalogFilterBlock title="Ширина фишки" :default_open="false"
                            v-if="catalogStore.category_id === 3">
            <div v-if="catalogStore.loadings.filter_limits_loaded">
                <VueSlider v-model="catalogStore.filter.chip_width"
                           :min="catalogStore.filter_data.limits.chip_width[0]"
                           :max="catalogStore.filter_data.limits.chip_width[1]"
                           :interval="catalogStore.chipWidthInterval"
                           :silent="true"
                           tooltip="none"/>
                <div class="grid grid-cols-2 gap-5 mt-4">
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput placeholder=" " name="cf_chip_width_from" id="cf_chip_width_from"
                                              :min="catalogStore.filter_data.limits.chip_width[0]"
                                              :max="catalogStore.filter_data.limits.chip_width[1]"
                                              v-model="catalogStore.filter.chip_width[0]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_chip_width_from"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Ширина от
                        </label>
                    </div>
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_chip_width_to" id="cf_chip_width_to" placeholder=" "
                                              :min="catalogStore.filter_data.limits.chip_width[0]"
                                              :max="catalogStore.filter_data.limits.chip_width[1]"
                                              v-model="catalogStore.filter.chip_width[1]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"
                        />
                        <label for="cf_chip_width_to"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Ширина до
                        </label>
                    </div>
                </div>
            </div>
            <CatalogFilterBlockLoading v-else/>
        </CatalogFilterBlock>
        <!--Фишки разного размера-->
        <CatalogFilterBlock title="Фишки разного размера" :default_open="false"
                            v-if="catalogStore.category_id === 3">
            <div v-for="(item, key) in catalogStore.filter_data.is_chip_mix_sized" :key="key" class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-is_chip_mix_sized-' + key"
                                    :value="item.value"
                                    :disabled="item.count === 0"
                                    v-model="catalogStore.filter.is_chip_mix_sized"/>
                    <label :for="'filter-is_chip_mix_sized-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.value ? 'Да' : 'Нет' }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
        <!--Форма фишки-->
        <CatalogFilterBlock title="Форма фишки" :description="filterDescriptions.chip_types"
                            :default_open="false" v-if="catalogStore.filter_data.chip_types.length">
            <div v-for="(item, key) in catalogStore.filter_data.chip_types" :key="key" class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-chip_types-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.chip_types"/>
                    <label :for="'filter-chip_types-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
        <!--Тип скрепления-->
        <CatalogFilterBlock title="Тип скрепления" :description="filterDescriptions.fastenings"
                            :default_open="false" v-if="catalogStore.filter_data.fastenings.length">
            <div v-for="(item, key) in catalogStore.filter_data.fastenings" :key="key" class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-fastenings-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.fastenings"/>
                    <label :for="'filter-fastenings-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
        <!--Материал-->
        <CatalogFilterBlock title="Материал"
                            :enableSearch="catalogStore.filter_data.materials.length > 7"
                            searchPlaceholder="Поиск по материалу"
                            v-slot="{ searchQuery }"
                            :default_open="false" v-if="catalogStore.filter_data.materials.length">
            <div v-for="(item, key) in filterOptionsByQuery(catalogStore.filter_data.materials, searchQuery)" :key="key"
                 class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-materials-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.materials"/>
                    <label :for="'filter-materials-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
            <p v-show="!filterOptionsByQuery(catalogStore.filter_data.materials, searchQuery).length"
               class="text-sm text-gray-500 pt-2">Ничего не найдено</p>
        </CatalogFilterBlock>
        <!--Тип рельефа-->
        <CatalogFilterBlock title="Тип рельефа"
                            :default_open="false" v-if="catalogStore.filter_data.terrains.length">
            <div v-for="(item, key) in catalogStore.filter_data.terrains" :key="key" class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-terrains-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.terrains"/>
                    <label :for="'filter-terrains-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
        <!--Износостойкость-->
        <CatalogFilterBlock title="Износостойкость" :default_open="false"
                            v-if="catalogStore.filter_data.resistances.length">
            <div v-for="(item, key) in catalogStore.filter_data.resistances" :key="key" class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-resistances-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.resistances"/>
                    <label :for="'filter-resistances-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
        <!--Противоскольжение-->
        <CatalogFilterBlock title="Противоскольжение" :default_open="false"
                            v-if="catalogStore.filter_data.anti_slips.length">
            <div v-for="(item, key) in catalogStore.filter_data.anti_slips" :key="key" class="py-2">
                <div class="flex items-center">
                    <CustomCheckbox :id="'filter-anti_slips-' + key"
                                    :value="item.id"
                                    v-model="catalogStore.filter.anti_slips"/>
                    <label :for="'filter-anti_slips-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span class="flex items-center gap-2">
                            {{ item.title }}
                        </span>
                        <span class="text-sm font-medium text-gray-900">
                            ({{ item.count ?? 0 }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
    </div>
    <CatalogFilterLoading v-else/>
</template>

<style scoped lang="scss">
.yellow-border:before {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100px;
    height: 2px;
    background: var(--main-color);
    transition: left .3s;
}

.yellow-border-rtl:before {
    left: calc(100% - 100px);
}
</style>
